import React from "react";
import { connect } from "react-redux";
import { CaptureInfo, Sidebar } from "../../components/Onboard";
import { OnboardLayout } from "../../Layout";

class OnboardMerchantScreen extends React.Component {
  state = {
    isLoading: false,
  };

  render() {
    return (
      <OnboardLayout>
        <CaptureInfo />
        <Sidebar />
      </OnboardLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(OnboardMerchantScreen);
